<div class="review-summary">
  <div class="cx-review-summary-card simple-card po-box">
    <div class="w-100">
      <p class="title m-0 d-flex v-center">
        <span class="material-symbols-outlined icon"> category </span>

        <span class="m-b-0">{{ 'reviewItems.items' | cxTranslate }}</span>
      </p>
    </div>
  </div>

  <div class="m-t-20">
    <custom-cx-cart-item-list
      [items]="cartOrder.entries || []"
      [readonly]="readonly"
      [displayDates]="displayDates"
      [displayValues]="displayValues"
    ></custom-cx-cart-item-list>
  </div>
</div>